module.exports = __webpack_public_path__ + "img/front_fire_bump.b0c93fba.jpg";